import React from 'react';
import { SideBar } from '../navigation/SideBar';
import { TopNavigationBar } from '../navigation/TopNavigationBar';

export const LeftNavigationAndTopNavigationLayout = () => {
  return <header>
    <TopNavigationBar />
    <SideBar />
  </header>
}